// Public landing page for /business — funnels store owners into signup.

import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../Seo';
import './BusinessLanding.css';

export default function BusinessLanding() {
  return (
    <div className="biz-page">
      <Seo
        path="/business"
        title="Tudu for Business — Reach Local Shoppers with Deals & Coupons"
        description="Put your store's deals and coupons in front of nearby shoppers. Join Tudu for Business to publish flyers, track redemptions, and grow foot traffic."
      />
      <header className="biz-nav">
        <Link to="/business" className="biz-nav-brand">TUDU<span>Business</span></Link>
        <div className="biz-nav-actions">
          <Link to="/login">Sign in</Link>
          <Link to="/business/signup" className="biz-cta">Get started</Link>
        </div>
      </header>

      <section className="biz-hero">
        <div>
          <span className="biz-eyebrow">For local stores</span>
          <h1>Put your weekly deals in front of <em>real shoppers nearby</em>.</h1>
          <p>
            Upload your flyer, run digital coupons, and reach TUDU users who are
            already planning their shopping trips. Our AI parses your flyer into
            individual deals — no manual data entry, no listing fees per item.
          </p>
          <div className="biz-hero-cta-row">
            <Link to="/business/signup" className="biz-cta">Apply for an account</Link>
            <Link to="/login" className="biz-secondary">I already have one</Link>
          </div>
        </div>
        <div className="biz-hero-card">
          <h4>What you'll need to sign up</h4>
          <ul>
            <li>Your business name, address, and WhatsApp number</li>
            <li>One contact person + login email</li>
            <li>A business license or registration document</li>
            <li>An ID for the contact person</li>
          </ul>
        </div>
      </section>

      <section className="biz-features">
        <div className="biz-feature">
          <h3>AI flyer parsing</h3>
          <p>Snap a photo of your weekly flyer. GPT-4 Vision extracts every deal, price, and section — usually in under 30 seconds.</p>
        </div>
        <div className="biz-feature">
          <h3>Digital coupons</h3>
          <p>Create clip-to-wallet coupons with redemption codes. Customers redeem in-store; you see the claim and redemption counts.</p>
        </div>
        <div className="biz-feature">
          <h3>Simple billing</h3>
          <p>One monthly fee plus a small commission on tracked sales. Tiers from Free to Pro — start small, grow as you go.</p>
        </div>
      </section>

      <section className="biz-footer-cta">
        <h2>Ready to reach more shoppers this week?</h2>
        <p>Applications are reviewed within 1–2 business days. You'll be notified by email.</p>
        <Link to="/business/signup" className="biz-cta">Start your application</Link>
      </section>
    </div>
  );
}
